"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsDetail = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var NewsDetail = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(NewsDetail, _super);
    function NewsDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '新闻资讯正文';
        _this.code = '106020';
        _this.desc = '新闻资讯正文';
        _this.requestParams = new zl_1.NewsDetailRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return NewsDetail;
}(service_1.BaseService));
exports.NewsDetail = NewsDetail;
//# sourceMappingURL=newsDetail.js.map